import { observer } from 'mobx-react'
import { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import GlobalState from '../../../../stores/GlobalState'
import Option from '../../../common/Select/Option'
import { ReactComponent as Plus } from '../../../../assets/about/Vector.svg'
import ThingsMenu from '../../things/ThingsMenu'
import ThingsScroll from '../../things/ThingsScroll'
import ContentState from '../../../../stores/ContentState'
import ThingsCan from '../../things/ThingsCan'
import Directions from '../../things/Directions'
import PopularShops from '../../things/PopularShops'
import FamousShops from '../../things/FamousShops'
import Terms from '../../things/Terms'
import Arrange from '../../things/Arrange'
import HowItWork from '../../things/HowItWork'
import Support from '../../things/Support'
import SupportVidpravka from '../../things/SupportVidpravka'
import { runInAction } from 'mobx'
import './index.scss'
import classNames from 'classnames'
import NewSelectMenu from '../../things/NewMenu'
import SeoBlock from '../../../common/SeoBlock'

const SingleProduct = observer(
  ({ menu, banners, blocks }: { menu: any; banners: any; blocks: any }) => {
    const { pathname } = useLocation()
    const { params } = useParams()
    const [selectedTab, setSelectedTab] = useState(0)
    const navigate = useNavigate()

    const [selected, setSelected] = useState('')

    // const onSelectHandler = (selectedOption: string) => {
    //   console.log(selectedOption)
    //   if (!menu || !menu?.list?.length) return
    //   const _selectedTabId = menu?.list?.findIndex(
    //     (child: any) => child?.title === selectedOption,
    //   )
    //   if (_selectedTabId !== -1) {
    //     setSelectedTab(_selectedTabId)
    //   }
    // }
    let lang = GlobalState.currentLocale.lang.includes('En')
      ? '/en'
      : GlobalState.currentLocale.lang.includes('ру')
      ? '/ru'
      : ''

    let page = pathname.includes('for-you') ? '/for-you/' : '/for-business/'

    useEffect(() => {
      let res = menu?.list.find((me: any) => pathname == me.link)

      if (res) {
        setSelected(res.title)
      } else {
        res = blocks.find((bl: any) => {
          const link = lang + bl.linkblock + '/'

          if (pathname == link) return bl
        })

        if (res) {
          setSelected(res.info.catShort)
        }
      }
    }, [pathname, blocks, menu])

    useEffect(() => {
      if (ContentState.things) {
        const block = ContentState.things.blocks.find(
          (b: any) =>
            b.linkblock
              .replaceAll("/for-you/", "")
              .replaceAll("/for-business/", "") == params
        );

        runInAction(() => {
          ContentState.product = block
        })
      }
    }, [ContentState.things])

    const { product } = ContentState

    if (!product) return <></>
    return (
      <section className="things">
        <div className="things__mobile">
          {menu && menu?.list && (
            <NewSelectMenu defaultValue={selected}>
              {menu?.list?.map((item: any, i: number) => {
                let link = item.link.slice(1, item.link.length)
                link = GlobalState.currentLocale.lang.includes('En')
                  ? 'en/' + link
                  : GlobalState.currentLocale.lang.includes('ру')
                  ? 'ru/' + link
                  : link

                if (!i)
                  return (
                    <div className="select-submenu">
                      <Option value={item.title} key={i} link={link}>
                        {item.title}
                      </Option>

                      <div className="select-sublist">
                        {blocks?.map((bl: any, id: any) => {
                          const link = lang + bl.linkblock
                          return (
                            <a
                              className={classNames(
                                'select-option',
                                pathname.includes(link) && 'active',
                              )}
                              key={id}
                              href={link}
                            >
                              <span className="marker"></span>
                              <span> {bl.info.catShort}</span>
                            </a>
                          )
                        })}
                      </div>
                    </div>
                  )
                return (
                  <Option value={item.title} key={i} link={link}>
                    {item.title}
                  </Option>
                )
              })}
            </NewSelectMenu>
          )}
          <a
            href={lang + '/offices/'}
            className="button grey-border things-menu__departs"
          >
            <Plus /> {menu?.departments}
          </a>
        </div>
        <div className="things__top">
          {banners?.map((b: any, i: number) => (
            <div className="things__top-block" key={i}>
              <img src={b.bg} alt="" />
              <div
                className="things__top-title"
                dangerouslySetInnerHTML={{ __html: b.title }}
              ></div>
              <a
                className="button black"
                href={b.buttonLink.replaceAll('#', '')}
              >
                {b.buttonTitle}
              </a>
            </div>
          ))}
        </div>
        <div className="things__row">
          {menu && <ThingsMenu menu={menu} blocks={blocks} />}
          {blocks && pathname == lang + page && (
            <ThingsScroll blocks={blocks} />
          )}
          <div className="things__row-col single-product">
            <div className="single-product__top">
              <img src={product.info.catIcon} />
              <div className="single-product__title">
                {product.info.catShort}
              </div>
            </div>
            <div className="things-col__title">{product.info.title}</div>
            <div
              className="things-col__text"
              dangerouslySetInnerHTML={{ __html: product.info.text }}
            ></div>
            {!product.info.ch1 && <ThingsCan content={product.info.can} />}
            {!product.info.ch2 && (
              <Directions content={product.info.directs2} classname={'bg'} />
            )}
            {!product.info.ch3 && (
              <PopularShops content={product.info.popshops} />
            )}
            {!product.info.ch4 && (
              <Directions content={product.info.directs} classname={''} />
            )}
            {!product.info.ch10 && (
              <SupportVidpravka content={product.info.vidpravka} linkblock={params!} />
            )}
            {!product.info.ch9 && <FamousShops content={product.info.shops} />}

            {!product.info.ch5 && <Terms content={product.info.terms} />}
            {!product.info.ch6 && (
              <Arrange content={product.info.arrange} linkblock={params!} />
            )}
            {!product.info.ch7 && (
              <HowItWork content={product.info.howwork} linkblock={params!} />
            )}
            {!product.info.ch8 && (
              <Support content={product.info.support} linkblock={params!} />
            )}
            {product?.info?.subtext?.length > 0 && (
              <SeoBlock
                isLight={true}
                seo={{
                  title: '',
                  text: product?.info?.subtext,
                  button: product?.info?.subButon,
                }}
              />
            )}
          </div>
        </div>
      </section>
    )
  },
)

export default SingleProduct
